import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
    Box,
    Stack,
    Typography,
    Button,
} from '@mui/material';

import {
    lightBlue
} from '@mui/material/colors';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default function CtaSection(props) {
    const navigate = useNavigate();

    return (
        <Box sx={{
            marginTop: 2,
            padding: '108px 24px',
            background: `linear-gradient(180deg, ${lightBlue[700]}, ${lightBlue[900]})`,
        }}>
            <Stack
                spacing={4}
                direction="column"
                justifyContent="center"
                alignItems="center"
                sx={{ width: '100%' }}
            >
                <Typography
                    sx={{
                        fontFamily: 'NotoSansKR',
                        fontWeight: 900,
                        textAlign: 'center',
                        fontSize: { xs: '24px', md: '32px' },
                        color: '#ffffff',
                        maxWidth: '560px',
                        lineHeight: 1.4,
                    }}
                >
                    다끌레어에 대해<br />더 많은 정보를 알고 싶다면
                </Typography>

                <Typography
                    sx={{
                        fontFamily: 'NotoSansKR',
                        fontWeight: 400,
                        textAlign: 'center',
                        fontSize: '16px',
                        color: 'rgba(255,255,255,0.8)',
                        maxWidth: '420px',
                    }}
                >
                    제품 도입, 서비스 문의, 파트너십 등 무엇이든 편하게 연락주세요.
                    전문 담당자가 빠르게 답변드립니다.
                </Typography>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <Button
                        variant="contained"
                        endIcon={<ArrowForwardIcon />}
                        onClick={() => navigate('/company/contact?service=general')}
                        sx={{
                            fontFamily: 'NotoSansKR',
                            fontWeight: 700,
                            fontSize: '15px',
                            backgroundColor: '#ffffff',
                            color: lightBlue[800],
                            borderRadius: '50px',
                            px: 4,
                            py: 1.5,
                            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                            '&:hover': {
                                backgroundColor: 'rgba(255,255,255,0.92)',
                                boxShadow: '0 6px 24px rgba(0,0,0,0.25)',
                            },
                        }}
                    >
                        지금 바로 문의하기
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={() => navigate('/company/mission')}
                        sx={{
                            fontFamily: 'NotoSansKR',
                            fontWeight: 600,
                            fontSize: '15px',
                            color: '#ffffff',
                            borderColor: 'rgba(255,255,255,0.5)',
                            borderRadius: '50px',
                            px: 4,
                            py: 1.5,
                            '&:hover': {
                                borderColor: '#ffffff',
                                backgroundColor: 'rgba(255,255,255,0.08)',
                            },
                        }}
                    >
                        회사 소개 보기
                    </Button>
                </Stack>
            </Stack>
        </Box>
    );
}